module.exports = __webpack_public_path__ + "media/images/coiffeur-b7242f76db84070782d8c4ea96c6e7af.svg";